// @flow
import ApiObject from '../ApiObject';

export default class OrderSource extends ApiObject {

  identifier: string;

  platform: string;

  postJsonAssignation(data: Object) {
  }

  getIdentifier(): string {
    return this.identifier;
  }

  getPlatform(): string {
    return this.identifier;
  }
}



// WEBPACK FOOTER //
// ./sdk/scripts/entities/order/OrderSource.js